import css from './BalancePage.css';

export const balancePageTabs = ({ selectedPage }) => [
    {
        text: 'Bilanz',
        selected: selectedPage === 'BalancePage',
        linkProps: {
            activeClassName: css.linkActive,
            name: 'BalancePage',
        },
    },
    {
        text: 'Rewards',
        selected: selectedPage === 'RewardsPage',
        linkProps: {
            activeClassName: css.linkActive,
            name: 'RewardsPage',
        },
    },
];
